import { MainWrapper } from '../UI/components/UIKit/Wrapper'
import TitleList from '../modules/TitleList/TitleList'

const TitlePage = () => {
  return (
    <MainWrapper>
      <TitleList/>
    </MainWrapper>
  )
}

export default TitlePage